import { css } from '@emotion/react';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { media } from '../../../../styles/breakpoints-2026';

const { spacing, colors, typography } = tokens;

const TETHER_ELEMENT = '.horizontal-tether-open-element';
const TETHER_PINNED_RIGHT = '.horizontal-tether-open-pinned-right';

const POPOUT_INNER_PADDING = spacing.xs;
const inset = (value: string) => `calc(${value} - ${POPOUT_INNER_PADDING})`;
const insetBetweenSections = (value: string) =>
  `calc(${value} - ${POPOUT_INNER_PADDING} * 2)`;

export const filter = css`
  .horizontal-dropdown-pills {
    padding: 0;
    overflow: visible;
    background: transparent;

    ${media('<tablet')} {
      margin-top: calc(-1 * ${spacing.s});
      padding-top: ${spacing.s};
    }
  }

  button.active {
    &,
    &:hover,
    &:focus {
      color: ${colors.interactive.base.default};
    }

    &:active {
      color: ${colors.interactive.base.pressed};
    }
  }
`;

export const pinnedPopoutRespectsPageMargin = css`
  ${media('>=desktop', '<lrg-desktop')} {
    ${TETHER_ELEMENT}${TETHER_PINNED_RIGHT} {
      translate: calc(-1 * ${spacing.m}) 0;
    }
  }
`;

export const panel = css`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: ${spacing.s};
  padding: ${inset(spacing.l)} ${inset(spacing.m)} 0;
`;

export const title = css`
  ${applyFont(typography.body)}
  display: flex;
  align-items: center;
  gap: ${spacing.xs};
  color: ${colors.neutral.heavy.default};
`;

export const options = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.s};

  width: 100%;
`;

export const radioRow = css`
  width: 100%;

  > * {
    width: 100%;
  }

  label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: ${spacing.s};
    width: 100%;
    text-align: left;
  }
`;

export const optionLabel = css`
  ${applyFont(typography.body)}
  color: ${colors.neutral.heavy.default};
  text-align: left;
`;

export const actions = css`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing.s};
  padding: ${insetBetweenSections(spacing.l)} ${inset(spacing.m)}
    ${inset(spacing.m)};
`;

export const cancelButton = css`
  color: ${colors.neutral.heavy.default};
  border-color: ${colors.neutral.trim.default};

  &:hover,
  &:focus {
    color: ${colors.neutral.heavy.hover};
    border-color: ${colors.neutral.trim.hover};
    background: ${colors.neutral.surface.hover};
  }
`;
